var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-page" }, [
    _c("section", { staticClass: "linear-hero" }, [
      _c("div", [
        _c(
          "p",
          { staticClass: "linear-kicker" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [_vm._v("Home")]),
            _vm._v(" "),
            _c("span", [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v("Blank")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", [_vm._v("Blank")]),
        _vm._v(" "),
        _c("p", { staticClass: "linear-copy" }, [
          _vm._v("A quiet command surface reserved for future admin content."),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "linear-empty", attrs: { role: "status" } },
      [
        _c(
          "div",
          {
            staticClass: "linear-empty__icon",
            attrs: { "aria-hidden": "true" },
          },
          [_c("admin-icon", { attrs: { name: "file" } })],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "linear-label" }, [_vm._v("Workspace")]),
        _vm._v(" "),
        _c("h2", [_vm._v("Blank page")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "This page is ready for content. Add modules, forms, or operational context when the workflow is defined."
          ),
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass:
              "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
            attrs: { to: "/home" },
          },
          [_vm._v("Back to home")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "linear-command-card" }, [
      _c("span", { staticClass: "linear-dot" }),
      _vm._v(" "),
      _c("span", [_vm._v("Ready for content")]),
      _vm._v(" "),
      _c("kbd", [_vm._v("Empty")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }